import { styled } from "@mui/system"
import ICPNumberChip from "../../styled/ICPNumberChip"
import PersonIcon from '@mui/icons-material/Person';
import useFetchJson from "../../../data/useFetchJson";
import { DebugBox } from "@northpowerdev/np-react-utils";

const { Box, Typography, Stack, Avatar, Divider, Button } = require("@mui/material")
const { useNavigateWithParams, LoadingBox, dateFromISO } = require("@northpowerdev/np-react-utils")
const { useEffect } = require("react")

const LocalStyledTypography = styled(Typography)(({theme}) => ({
    display: 'inline-block',
    padding: '0.5em',
    border: '1px solid gray',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    backgroundColor: 'rgba(224, 82, 31, 0.12)',
    borderColor: 'rgba(0, 0, 0, 0.12)',
}));

export default function QRTagDetailsWithTagId({tagId}) {

    const baseUrl = '/bff/isolation-tags-service/api/tag'
    const {
        load: loadTagDetails,
        isLoading: tagDetailsLoading,
        data: tagDetails, // E.g. {"tagId":"Ibl1ThwyCr","updatedDate":"2022-11-16T17:00:26+13:00","tagStatus":"idle","updatedBy":{"name":null,"email":null,"phone":null},"isolationReason":null,"assetType":null,"assetId":null}
        // setData: setTagDetails
    } = useFetchJson(baseUrl)

    const navigateToEditPage = useNavigateWithParams('/tag/edit')
    // const navigateToFindPage = useNavigateWithParams('/tag/find')

    useEffect(() => {
        console.log('QRTagDetails useEffect getting tag details')
        if (!tagId) {
            //
            // No tagId in url parameters. Don't try to load anything.
            //
            console.log('QRTagDetails useEffect DEBUG no tag id!')
            return
        }
        const fullUrl = baseUrl + '/' + tagId + '/read'
        console.log('loading tag details in background')
        loadTagDetails({}, fullUrl) // run in background. Updates tagDetails
    // eslint-disable-next-line
    }, [tagId])


    const handleChangeStatus = () => {
        console.log('handleChangeStatus')
        navigateToEditPage({tag_id: tagId})
    }

    return (
        <Box textAlign="center">
            <LoadingBox loading={tagDetailsLoading} message={"Loading tag " + tagId}>

                {
                    tagDetails?.assetId
                    &&
                    <Box>
                        <Typography variant="body1" sx={{fontSize: '1.3em'}}><ICPNumberChip icpNumber={tagDetails?.assetId} /></Typography>
                        
                    </Box>
                }
                <Box>
                    <LocalStyledTypography variant="h2" paragraph sx={{mt: 2}}>{tagDetails?.tagStatus}</LocalStyledTypography>
                </Box>
                {
                    tagDetails?.tagStatus === 'isolated'
                    &&
                    <>
                        <Box item xs={12} md={6}>
                            <Typography variant="h5" color="secondary" paragraph>{tagDetails?.isolationReason}</Typography>
                            <Stack direction="row" justifyContent="center">
                                <Avatar sx={{width:66, height:66, mr:2}}>
                                    <PersonIcon fontSize="large" />
                                </Avatar>
                                <Box textAlign="left">
                                    <Typography variant="body1">{tagDetails?.updatedBy?.name}</Typography>
                                    <Typography variant="body1">{tagDetails?.updatedBy?.email}</Typography>
                                    {tagDetails?.updatedBy?.phone && <Typography variant="body1">{tagDetails?.updatedBy?.phone}</Typography>}
                                    <Typography variant="body1">{dateFromISO(tagDetails?.updatedDate)}</Typography>
                                </Box>
                            </Stack>
                        </Box>
                    </>
                }
                <Divider sx={{my:4}} />
                <Box>
                    <Stack direction="row" justifyContent="center">
                        <Button variant="contained" onClick={handleChangeStatus} disabled={!tagDetails?.tagStatus}>Change Status</Button>
                    </Stack>
                </Box>

                <DebugBox title="tagDetails" stringify sx={{mt:4}}>{tagDetails}</DebugBox>
            </LoadingBox>
            <DebugBox title="tagDetailsLoading" stringify>{tagDetailsLoading}</DebugBox>
        </Box>
    )
}